import {DependencyList, useCallback, useEffect, useRef} from "react";

export const useReactiveHandler = <T>(handler: (data:T) => void, deps:DependencyList) => {
    const handlerRef = useRef(handler);
    const callback = useCallback(handler, [...deps,handler]);
    useEffect(() => {
        handlerRef.current = callback;
    }, [callback]);

    return (data: T) => {
        handlerRef.current(data);
    };
}
